import * as angular from "angular";
import {IController, IQService} from "angular";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {OrdersDialogService} from "../../services/order-dialogs-service.service";
import {OrderRequestsService} from "../../services/order-requests.service";
import {OrdersService} from "../../services/orders-service.service";
import {DeliveriesAlertsService} from "../../../deliveries/services/deliveries-alerts.service";
import {AccountModel} from "../../../account/angular/models/account.model";
import {ConfirmChangeStateService} from "../../../commons/services/confirm-change-state.service";

export class createOperationViewCtrl implements IController {

  order: any;
  account: AccountModel;
  pricePlanBundle: any;
  defaultProgramType: any;
  isDuplicate: boolean;
  quote: any;
  onSubmit: Function;

  private loading: any;

  /* @ngInject */
  constructor(private $log, private $state, private orderRequestsService: OrderRequestsService, private ordersDialogService: OrdersDialogService,
              private ordersService: OrdersService, private deliveriesAlertsService: DeliveriesAlertsService,
              private deliveriesConstants, private confirmChangeStateService: ConfirmChangeStateService, private bringozLoaderService: BringozLoaderService,
              private $q: IQService) {
  }

  onSubmitOrder(order, isShouldSendSms, form, $event) {
    this.loading = true;
    this.bringozLoaderService.on();
    this._ConfirmOrder($event)
      .then(() => {
        if (this.order.serviceList[0].packageList[0]?.items?.length) {
          this.order.serviceList[0].packed = true;
        }
        return this.orderRequestsService.placeOrder(this.order, this.order.accountId, isShouldSendSms);
      })
      .then((createdOrder) => {
        this.order = this.ordersService.getEmptyOperationOrder(this.account, undefined, this.pricePlanBundle, this.defaultProgramType);
        form.$setPristine();
        form.$setUntouched();
        this.deliveriesAlertsService.createFieldServiceSuccess(createdOrder.serviceList[0], true)
          .then((res) => {
            // If confirmed prompt goes to detailed-operation-info
            if (res) {
              this.confirmChangeStateService.reset();
              this.$state.go(this.deliveriesConstants.redirectLinkByTextTriggerGroup.Operation,
                {id: createdOrder.serviceIdList[0]});
            }
          });
      })
      .catch((error) => {
        if (error) {
          if (error.code === 400301) {
            this.deliveriesAlertsService.outOfServiceZoneError();
          } else if (error.code === 400306) {
            this.deliveriesAlertsService.invalidDeliveryDayError();
          } else {
            this.deliveriesAlertsService.createFieldServiceError();
          }
          this.$log.error('createOrderFlowError', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      })
      .finally(() => {
        this.loading = false;
        this.bringozLoaderService.off();
      });
  }

  onCancel() {
    this.$state.go(this.deliveriesConstants.redirectLinkByTextTriggerGroup.Operation, {
      id: this.order.serviceList[0].id
    });
  }

  _ConfirmOrder(event) {
    return this.orderRequestsService.getOrderPrice(this.order, this.order.accountId)
      .then((orderPrice) => { // Confirm Price
        this.order.serviceList[0].billing = orderPrice.serviceBillings[0];
        return this.ordersDialogService.confirmOrderSummary(event, orderPrice);
      })
      .then((paymentMethod) => { // Place Order
        this.order.pmid = paymentMethod;
        return this.$q.when();
      });
  }

}

angular
  .module('bringoz.admin.orders')
  .component('createOperationView', {
    bindings: {
      order: '<',
      account: '<',
      pricePlanBundle: '<',
      defaultProgramType: '<',
      isDuplicate: '<?',
      quote: '<?',
      onSubmit: '&'
    },
    template: require('./create-operation-view.html').default,
    controller: createOperationViewCtrl
  });
